import { createContext } from 'react';

import type { IExportsContext } from 'SharedComponents/hooks/useExports';

export const exportsStateInitialState = {
    exportInFlight: false,
    totalChunks: 0,
    chunkCounter: 0,
    RecordType: '',
    filterQuery: '',
    exportError: ''
};

const ExportsContext = createContext<IExportsContext>({
    ...exportsStateInitialState,
    setExportsContext: () => ({})
});

export { ExportsContext };